import { render, staticRenderFns } from "./manage-admin.vue?vue&type=template&id=41d790d2&scoped=true"
import script from "./manage-admin.vue?vue&type=script&lang=ts&setup=true"
export * from "./manage-admin.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./manage-admin.vue?vue&type=style&index=0&id=41d790d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d790d2",
  null
  
)

export default component.exports